import Vue from 'vue'
import Router from 'vue-router'
import Index from "../pages/Index";
import Case from "../pages/Case";
import About from "../pages/About";
import News from "../pages/News";
import Partner from "../pages/Partner";
import Contact from "../pages/Contact";
import Detail from "../pages/Detail";
import Honour from "../pages/Honour";
import CaseDetail from "../pages/CaseDetail";
import BookDetail from "../pages/BookDetail";
import SubDetail from "../pages/SubDetail";
import ItemList from "../pages/ItemList";


Vue.use(Router);

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {path: '/', name: 'Index', component: Index},
    {path: '/case', name: 'Case', component: Case},
    {path: '/about', name: 'About', component: About},
    {path: '/new', name: 'News', component: News},
    {path: '/partner', name: 'Partner', component: Partner},
    {path: '/contact', name: 'Contact', component: Contact},
    {path: '/detail', name: 'Detail', component: Detail},
    {path: '/caseDetail', name: 'CaseDetail', component: CaseDetail},
    {path: '/bookDetail', name: 'BookDetail', component: BookDetail},
    {path: '/subDetail', name: 'SubDetail', component: SubDetail},
    {path: '/honour', name: 'Honour', component: Honour},
    {path: '/case', name: 'Case', component: Case},
    {path: '/item-more', name: 'ItemList', component: ItemList},

  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js